
import {styled} from "@mui/material/styles";
import Button from "@mui/material/Button";


const StyledBtn = styled(Button)(({theme}) => ({
    background: 'primary',
    color: 'primary.contrastText',
    height: 35,
    paddingLeft: 10,
    paddingRight: 10,
    // border:"1px solid lightgrey",
    marginTop: 10,
    marginBottom: 10,  
    marginLeft: 10,
    textTransform: 'none',
    "&:hover": {
        background: 'secondary.main',
    },
    "&:active": {
        transform: "translate(0px,3px)",
    }
}))

export default function StyledButton(props){

    return (
        <StyledBtn
            variant={"contained"}
            color={"primary"}
            {...props}
        >{props.children}
        </StyledBtn>
    )
}